export const  GET_COOKIES_POLICY_SUCCESS='cookiesReducer/GET_COOKIES_POLICY_SUCCESS';
export const  GET_COOKIES_POLICY_REQUEST='cookiesReducer/GET_COOKIES_POLICY_REQUEST';
export const  GET_COOKIES_POLICY_FAILED='cookiesReducer/GET_COOKIES_POLICY_FAILED';